import slusanost from '../images/slusanost.jpg';

export default function Audience() {
  
    return (
      <div className='Audience'>
        <img src={slusanost} alt="slusanost"></img>
      </div>
    );
  }